<template>
	<v-sheet elevation="0">
		<v-row no-gutters>
			<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''" cols="12" md="6">
				<v-row no-gutters class="px-1 pt-2 show-unit">
					<v-col cols="12" :sm="dialogMode ? 12 : 3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
						<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">基本情報</h4>
					</v-col>
					<v-col cols="12" :sm="dialogMode ? 12 : 9">
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">作成日</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.created_at | dateFormatter }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">最終更新日</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.updated_at | dateFormatter }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">案件名</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.name }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">見積番号</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{ matter.quotation_number }}-{{ matter.quotation_sub_number }}
								</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">成約したかどうか</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2" v-if="matter.contract == true">成約</p>
								<p class="text-body-2" v-if="matter.contract == false">失注</p>
								<p class="text-body-2" v-if="matter.contract == null">未定</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">商品区分(主区分)</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.product_category.name }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">分類区分(副区分)</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.product_sub_category.name }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">チーム</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.team ? matter.team.name : "" }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">本件の担当者</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{ teamMemberName }}
								</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">受注確度</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.situation_ja ? matter.situation_ja : "" }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">流れ品か否か</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2" v-if="matter.regularly_sold == true">流れ品</p>
								<p class="text-body-2" v-if="matter.regularly_sold == false">否</p>
								<p class="text-body-2" v-if="matter.regularly_sold == null">未設定</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">案件の概要</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.description ? matter.description : "" }}</p>
							</v-col>
						</v-row>

						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">進捗状況及び契約までのポイント</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.points ? matter.points : "" }}</p>
							</v-col>
						</v-row>
					</v-col>
				</v-row>

				<v-row no-gutters class="px-1 pt-2 show-unit">
					<v-col cols="12" :sm="dialogMode ? 12 : 3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
						<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">顧客情報</h4>
					</v-col>
					<v-col cols="12" :sm="dialogMode ? 12 : 9">
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">得意先</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{ matter.regular_customer_company ? matter.regular_customer_company.name : "" }}
								</p>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">得意先担当者</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{
										matter.regular_customer_company_person
											? matter.regular_customer_company_person.name
											: ""
									}}
								</p>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">エンドユーザー</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{ matter.customer_company ? matter.customer_company.name : "" }}
								</p>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">エンドユーザー担当者</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{ matter.customer_person ? matter.customer_person.name : "" }}
								</p>
							</v-col>
						</v-row>
						<v-row v-if="matter.distribution_channel" no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">商流</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{ current_company_name ? current_company_name : "当社" }}
								</p>
								<p
									class="text-body-2"
									v-for="(company, i) in matter.distribution_channel.customer_companies"
									:key="i"
								>
									<span>→</span> {{ company.name }}
								</p>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>

			<v-col v-if="!$vuetify.breakpoint.mdAndUp" cols="12">
				<v-divider />
			</v-col>

			<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pl-2' : ''" cols="12" md="6">
				<v-row no-gutters class="px-1 pt-2 show-unit">
					<v-col cols="12" :sm="dialogMode ? 12 : 3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
						<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">競合・失注情報</h4>
					</v-col>
					<v-col cols="12" :sm="dialogMode ? 12 : 9">
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">競合先</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter.competitor ? matter.competitor : "" }}</p>
							</v-col>
						</v-row>
						<v-row
							no-gutters
							class="pb-2 show-detail-unit"
							v-if="!matter.contract && matter.contract !== null"
						>
							<v-col cols="4">
								<h4 class="text-body-2 font-weight-bold">失注先</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-2">{{ matter.lost_to ? matter.lost_to : "" }}</h4>
							</v-col>
						</v-row>
						<v-row
							no-gutters
							class="pb-2 show-detail-unit"
							v-if="!matter.contract && matter.contract !== null"
						>
							<v-col cols="4">
								<h4 class="text-body-2 font-weight-bold">失注理由</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-2">{{ matter.lost_reason ? matter.lost_reason : "" }}</h4>
							</v-col>
						</v-row>
					</v-col>
				</v-row>

				<v-row no-gutters class="px-1 pt-2 show-unit">
					<v-col cols="12" :sm="dialogMode ? 12 : 3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
						<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">金額情報</h4>
					</v-col>
					<v-col cols="12" :sm="dialogMode ? 12 : 9">
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">総原価</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{ matter.total_cost ? Number(matter.total_cost).toLocaleString() + "円" : "" }}
								</p>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h4 class="text-body-2 font-weight-bold">見積額（総額）</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-2">
									{{
										matter.quotation_amount
											? Number(matter.quotation_amount).toLocaleString() + "円"
											: ""
									}}
								</h4>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit" v-if="matter.contract">
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">受注額</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">
									{{
										matter.ordered_amount
											? Number(matter.ordered_amount).toLocaleString() + "円"
											: ""
									}}
								</p>
							</v-col>
						</v-row>
						<v-row no-gutters class="pb-2 show-detail-unit">
							<v-col cols="4">
								<h4 class="text-body-2 font-weight-bold">粗利</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-2">
									{{
										matter.ordered_amount && matter.total_cost
											? grossProfit.toLocaleString() + "円"
											: ""
									}}
								</h4>
							</v-col>
						</v-row>
						<v-row
							no-gutters
							class="pb-2 show-detail-unit"
							v-if="!matter.contract && matter.contract !== null"
						>
							<v-col cols="4">
								<h4 class="text-body-2 font-weight-bold">失注額</h4>
							</v-col>
							<v-col cols="8">
								<h4 class="text-body-2">
									{{ matter.lost_amount ? Number(matter.lost_amount).toLocaleString() + "円" : "" }}
								</h4>
							</v-col>
						</v-row>
					</v-col>
				</v-row>

				<v-row no-gutters class="px-1 pt-2 show-unit">
					<v-col cols="12" :sm="dialogMode ? 12 : 3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
						<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">詳細情報</h4>
					</v-col>
					<v-col cols="12" :sm="dialogMode ? 12 : 9">
						<v-row
							no-gutters
							class="pb-2 show-detail-unit"
							v-for="matter_value in matter.matter_values"
							:key="matter_value.id"
						>
							<v-col cols="4">
								<h5 class="text-body-2 font-weight-bold">{{ matter_value.matter_key.name }}</h5>
							</v-col>
							<v-col cols="8">
								<p class="text-body-2">{{ matter_value.basic_value }}</p>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<template v-if="showProductsInfo">
					<v-row no-gutters class="px-1 pt-2 show-unit">
						<v-col
							cols="12"
							:sm="dialogMode ? 12 : 3"
							:class="$vuetify.breakpoint.sm ? '' : 'pb-2'"
						>
							<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">製品情報</h4>
						</v-col>
						<v-col cols="12" :sm="dialogMode ? 12 : 9">
							<div v-for="matter_product in matter.matter_products" :key="matter_product.id">
								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="4">
										<h5 class="text-body-2 font-weight-bold">製品名</h5>
									</v-col>
									<v-col cols="8">
										<p class="text-body-2">{{ matter_product.product.name }}</p>
									</v-col>
								</v-row>
								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="4">
										<h4 class="text-body-2 font-weight-bold">サブネーム</h4>
									</v-col>
									<v-col cols="8">
										<h4 class="text-body-2">{{ matter_product.sub_name }}</h4>
									</v-col>
								</v-row>
								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="4">
										<h4 class="text-body-2 font-weight-bold">単価</h4>
									</v-col>
									<v-col cols="8">
										<h4 class="text-body-2">
											{{ Number(matter_product.unit_price).toLocaleString() + "円" }}
										</h4>
									</v-col>
								</v-row>
								<v-row no-gutters class="pb-2 show-detail-unit">
									<v-col cols="4">
										<h4 class="text-body-2 font-weight-bold">数量</h4>
									</v-col>
									<v-col cols="8">
										<h4 class="text-body-2">{{ matter_product.quantity }}</h4>
									</v-col>
								</v-row>
								<v-divider class="mb-2" />
							</div>
						</v-col>
					</v-row>
					<p
						v-if="matter.ordered_products.length && matter.ordered_products.length"
						class="btn-like my-3"
						@click="orderedProductDialog = true"
					>
						受注製品情報
					</p>
					<p
						v-if="
							matter.ordered_products.length &&
							isPresent(matter.ordered_products[0].order_individual_infos)
						"
						class="btn-like my-3"
						@click="orderIndividualInfoDialog = true"
					>
						製造単位別製品情報
					</p>
				</template>
			</v-col>
		</v-row>
		<template v-if="showProductsInfo">
			<OrderedProductDialog
				v-if="orderedProductDialog"
				:ordered_products="matter.ordered_products"
				@close="orderedProductDialog = false"
			/>
			<OrderIndividualInfoDialog
				v-if="orderIndividualInfoDialog"
				:ordered_products="matter.ordered_products"
				@close="orderIndividualInfoDialog = false"
			/>
		</template>
	</v-sheet>
</template>

<script>
import moment from "moment/min/moment.min.js"
import OrderedProductDialog from "./OrderedProductDialog.vue"
import OrderIndividualInfoDialog from "./OrderIndividualInfoDialog.vue"

export default {
	props: {
		matter: {
			type: Object,
			required: true,
			default: () => {},
		},
		current_company_name: {
			type: String,
			required: false,
		},
		showProductsInfo: {
			type: Boolean,
			required: false,
			default: true,
		},
		dialogMode: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		OrderedProductDialog,
		OrderIndividualInfoDialog,
	},
	data() {
		return {
			orderedProductDialog: false,
			orderIndividualInfoDialog: false,
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	methods: {
		isPresent(obj) {
			return Object.keys(obj).length
		},
	},
	computed: {
		grossProfit() {
			return Number(this.matter.ordered_amount - this.matter.total_cost)
		},
		teamMemberName() {
			if (this.matter.team_member_name) {
				return this.matter.team_member_name
			} else if (this.matter.team_member?.user) {
				return this.matter.team_member.user.full_name
			} else {
				return ""
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.btn-like {
	max-width: 256px;
	padding: 4px 8px;
	border: solid 1px gray;
	border-radius: 4px;
	cursor: pointer;
	box-shadow: 2px 2px 4px gray;
	&:active {
		box-shadow: none;
		margin-top: 2px;
		margin-left: 2px;
	}
}
</style>
